<template>
    <section class="plugin-home-tabs-big-item" v-show="activeId === itemId">
        <div class="plugin-home-tabs-big-item__content">
            <slot />
        </div>
        <div class="plugin-home-tabs-big-item__image">
            <plugin-home-image
                v-bind:image="image"
                v-bind:title="imageText"
                theme="gray"
            />
        </div>
    </section>
</template>

<script>
// import utils from '~/utils';

export default {
    name: 'plugin-home-tabs-big-item',
    props: {
        title: {
            type: String,
            default: '',
        },
        image: {
            type: String,
            default: '',
        },
        imageText: {
            type: String,
            default: '',
        },
        itemId: {
            type: String,
            default: '',
        },
        activeId: {
            type: String,
            default: '',
        },
    },
    data: () => ({

    }),
    methods: {

    },
    mounted() {

    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-tabs-big-item {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;

    &__content {
        > *:not(:last-child) {
            border-bottom: 2px solid @color-gray-light-secondary;
        }
    }

    &__image {
        height: 430px;
    }

    @media @media-md-down {
        display: flex;
        flex-direction: column-reverse;

        &__image {
            height: 240px;
        }
    }
}
</style>
